module.exports = __webpack_public_path__ + "img/type.6a307d96.png";